var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-watched"},[_c('CheckCircleIcon'),_c('div',[_vm._v(" "+_vm._s(_vm.$t("all_watched"))+" ")]),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.$emit('refetch')}}},[_vm._v(" "+_vm._s(_vm.$t("refresh"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }